module.exports = __webpack_public_path__ + "img/phone.2862af70.svg";